import React from 'react';
import { Button, Badge, Card } from './ui';
import { FileText, Zap, ShieldCheck, Lock, Star, XCircle, CheckCircle, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-4 pb-16 md:pt-6 md:pb-24 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-12" data-mp="38xf3du36dhxr">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-13" data-mp="3du5j2gb2ibin"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-14" data-mp="33xstnumk2jtp">
        <div className="inline-flex items-center gap-2 mb-4" data-id="element-15" data-mp="2q64chcxg955v">
          <span className="text-2xl" data-id="element-16" data-mp="2q7z234jo1lga">🧩</span>
          <span className="text-brand-400 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-17" data-mp="2u77uo62yzda9">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-6xl font-black text-white mb-4 tracking-tight text-[26px]" data-id="element-18" data-mp="2ga1emj9mrsoq">
          ¿Tu hijo no te hace caso
          <br data-id="element-19" data-mp="2motw5szffumv" />
          <span className="text-brand-400 text-glow" data-id="element-20" data-mp="2mobycrx498cu">
            hasta que terminás levantando la voz?
          </span>
        </h1>

        <div className="relative mt-4 mb-6 flex justify-center" data-id="element-21" data-mp="2hp8tp8l1t45e">
          <div className="absolute inset-0 bg-brand-500/20 blur-[80px] rounded-full pointer-events-none" data-id="element-22" data-mp="2vq1prxr007am"></div>
          <img src="https://cdn.magicpatterns.com/uploads/vTAdqR1mo4KTmVfM83zDZp/mockup_landing_.png" alt="Kit de Conducta Infantil — los 3 tomos y los 5 bonos prácticos en formato digital" className="relative z-10 w-full max-w-lg h-auto drop-shadow-2xl pl-[45px] pr-[45px]" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" data-id="element-23" data-mp="2qq6wjnjr35me" />
        </div>

        <p className="md:text-xl text-slate-300 mb-4 font-medium max-w-3xl mx-auto text-[16px]" data-id="element-24" data-mp="1ka3ctisp9144">
          KIT DE CONDUCTA INFANTIL
        </p>

        <p className="text-slate-400 max-w-2xl mx-auto text-[14px] mt-[3px] mb-[3px]" data-id="element-25" data-mp="1faqpkwxx1s10">
          Herramientas prácticas para entender mejor su conducta, acompañar
          rabietas y emociones, poner límites claros y construir mejores rutinas
          sin convertir cada momento del día en una pelea.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-8 overflow-x-auto" data-id="element-26" data-mp="3p44c7dn213bm">
          <Badge className="whitespace-nowrap" data-id="element-27" data-mp="3u1w8skyn9dm5">
            <FileText className="w-4 h-4 mr-2" data-id="element-28" data-mp="2wex6nup6ndgv" /> 100% Digital
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-29" data-mp="2wh06t7k1umzb">
            <Zap className="w-4 h-4 mr-2 text-amber-400" data-id="element-30" data-mp="31et9vrq230vd" /> Acceso inmediato
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-31" data-mp="36bs3881wb3si">
            <span className="mr-2" data-id="element-32" data-mp="36f7knhj1kox3">🧩</span> 3 Tomos + 5 Bonos
          </Badge>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-33" data-mp="3acc15duambfp">
          <Button size="md" className="w-full md:w-auto group" onClick={() => document.getElementById('planes')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-34" data-mp="llkmahrum9jz">
            <span className="mr-2 text-lg group-hover:scale-110 transition-transform" data-id="element-35" data-mp="264mx5a3tld6o">
              🧩
            </span>
            QUIERO MI KIT DE CONDUCTA INFANTIL AHORA
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-36" data-mp="21btv4tzqkiya" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400" data-id="element-37" data-mp="1rfqtrqcpkoce">
            <span className="flex items-center" data-id="element-38" data-mp="1mgnn61h2ya2b">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-400" data-id="element-39" data-mp="1mfw4tschu8tz" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-40" data-mp="1ifc5ci4g6t4o">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-41" data-mp="1dgiqomdfcw2x" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-42" data-mp="3cstolsxtl3tw">
              <Zap className="w-4 h-4 mr-1 text-blue-400" data-id="element-43" data-mp="3cslajxpynsh4" /> Acceso inmediato
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function Testimonials() {
  const placeholders = [{
    initials: '—',
    ring: 'bg-brand-900 text-brand-400'
  }, {
    initials: '—',
    ring: 'bg-emerald-900 text-emerald-400'
  }, {
    initials: '—',
    ring: 'bg-blue-900 text-blue-400'
  }];
  return <section className="py-10 bg-slate-900/50 border-y border-slate-800" data-id="element-44" data-mp="20gzpjg1secea">
      <div className="max-w-6xl mx-auto px-4" data-id="element-45" data-mp="1lsliesxc81rx">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-46" data-mp="1lrtl9do3dvzj">
          <div data-id="element-47" data-mp="1qkwfzp4lvbhb">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-48" data-mp="1qkmrk5z7lcdq">3</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-49" data-mp="1csycpuxks9t2">
              Tomos prácticos
            </p>
          </div>
          <div data-id="element-50" data-mp="1grfnqpk4a4fr">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-51" data-mp="12tr059yo0j70">5</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-52" data-mp="12uixoqbtoqzx">
              Bonos incluidos
            </p>
          </div>
          <div data-id="element-53" data-mp="o720970i4403">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-54" data-mp="o6il1y28jtpr">100%</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-55" data-mp="o8va0v6ev4cb">
              Digital
            </p>
          </div>
          <div data-id="element-56" data-mp="y5rcok9mow8y">
            <p className="text-3xl font-bold text-white mb-1 flex items-center justify-center gap-1" data-id="element-57" data-mp="y69dzvb5e0nq">
              <Zap className="w-7 h-7 fill-amber-400 text-amber-400" data-id="element-58" data-mp="t53p68klyxjh" />
            </p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-59" data-mp="1754ldapxhgsm">
              Acceso inmediato
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-60" data-mp="124qlwh2e7f67">
          {placeholders.map((p, idx) => <Card key={idx} className="bg-slate-900" data-id="element-61" data-mp="1gxsf1wlm34n4" data-mpi={idx}>
              <div className="flex gap-1 mb-4" data-id="element-62" data-mp="1bxnyy7om8bxf">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-slate-700" data-id="element-63" data-mp="1pxfliwt770n1" data-mpi={i} />)}
              </div>
              <p className="text-slate-500 italic mb-6" data-id="element-64" data-mp="1lvu3kx1t3w5z">
                [INSERTAR TESTIMONIO REAL]
              </p>
              <div className="flex items-center gap-3" data-id="element-65" data-mp="1szjyuo3reali">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${p.ring}`} data-id="element-66" data-mp="1xwk97b7n5zif">
                  {p.initials}
                </div>
                <div data-id="element-67" data-mp="27nexel4g796i">
                  <p className="font-bold text-slate-400" data-id="element-68" data-mp="27none8phtgc7">
                    [INSERTAR TESTIMONIO REAL]
                  </p>
                  <p className="text-xs text-slate-600" data-id="element-69" data-mp="2bqkylecpea64">—</p>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-70" data-mp="2lktqq0xto13r">
      <div className="max-w-3xl mx-auto" data-id="element-71" data-mp="2qm0wxvkbgs8b">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-72" data-mp="2qkzjjkftvtnf">
          ¿Cuántas veces más vas a tener que repetir lo mismo?
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-73" data-mp="w6yeuixlkcff">
          Querés que te escuche. Querés poner límites. Querés acompañarlo sin
          que todo termine en una discusión. Pero llega el momento real:
          “Guardá los juguetes.” Nada. “Vamos, guardá los juguetes.” Nada. “Te
          dije que guardes los juguetes.” Lo pedís. Lo repetís. Insistís.
          Intentás explicarle. Negociás. Te frustrás. Y terminás levantando la
          voz. Después pasa todo... y aparece la culpa: “No quería reaccionar
          así.”
        </p>

        <p className="text-lg font-bold text-center text-brand-400 mb-6" data-id="element-74" data-mp="3ofjrbnx4vm2e">
          No siempre es falta de paciencia. Muchas veces faltan herramientas
          claras para saber qué hacer EN ESE MOMENTO.
        </p>

        <Card className="bg-slate-900/80 border-red-900/30 mb-6" data-id="element-75" data-mp="3ehvw6wvm8cjp">
          <ul className="space-y-3" data-id="element-76" data-mp="2810n3z1k96jl">
            {['Guardar los juguetes termina en discusión', 'Apagar la tablet genera enojo o una rabieta', 'Bañarse se convierte en negociación', 'Vestirse a tiempo termina en conflicto', 'La hora de dormir parece otra batalla', 'Un simple “no” termina en llanto, enojo o frustración', 'Prometés mantener la calma pero terminás perdiendo la paciencia otra vez'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-77" data-mp="1ywn10toqumk" data-mpi={i}>
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-78" data-mp="21j1lkezuaea" />
                <span className="text-slate-300 text-lg" data-id="element-79" data-mp="pq2b239s4t7y">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-80" data-mp="fzh4ntnv6keh">
          ¿Y si esta fuera la última semana en la que tenés que improvisar
          frente a estos momentos?
        </h3>

        <p className="text-lg font-bold text-center text-white mb-3" data-id="element-81" data-mp="18oemjvo5yf6p">
          Criar con respeto no significa dejarlo hacer lo que quiera.
        </p>
        <p className="text-slate-400 text-center text-[15px] mb-4" data-id="element-82" data-mp="1dgfy1fdic1vo">
          Y poner límites tampoco significa tener que gritar para que te
          escuche. Muchos padres terminan atrapados entre dos extremos: gritar
          para conseguir obediencia o ceder para evitar el conflicto.
        </p>
        <div className="flex flex-wrap justify-center gap-2 text-sm font-medium text-brand-400 mb-4" data-id="element-83" data-mp="37ua6vcmz3udo">
          <span data-id="element-84" data-mp="32ws649j40lgr">Entender</span> <span className="text-slate-600" data-id="element-85" data-mp="32ycu1gax565n">→</span>
          <span data-id="element-86" data-mp="2f77buuhia1s6">Acompañar</span> <span className="text-slate-600" data-id="element-87" data-mp="2f6o6ed91l5v1">→</span>
          <span data-id="element-88" data-mp="2a7up09qmwupl">Poner límites</span> <span className="text-slate-600" data-id="element-89" data-mp="2a8mm5ozvr0hz">→</span>
          <span data-id="element-90" data-mp="2o747xh6862x9">Organizar</span>
        </div>
        <div className="grid sm:grid-cols-2 gap-3" data-id="element-91" data-mp="2o7vqnreq4664">
          {['Entender qué puede haber detrás de la conducta', 'Acompañar sus emociones sin abandonar el límite', 'Establecer límites con mayor claridad y consistencia', 'Crear rutinas que hagan el día más predecible'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-92" data-mp="43odx0jma3zl" data-mpi={i}>
              <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-93" data-mp="436c7oe6qxka" />
              <span className="text-slate-300" data-id="element-94" data-mp="3dy6w60vz7j">{item}</span>
            </div>)}
        </div>
        <p className="text-slate-400 text-center text-[15px] mt-6" data-id="element-95" data-mp="3rfh1cmpbn9k7">
          No necesitás tener una respuesta perfecta para todo. Necesitás
          herramientas que te ayuden a saber qué hacer cuando llega el momento
          difícil.
        </p>
      </div>
    </section>;
}